/* Raw Form announcement bar — rotates between messages.
   Pauses when the tab is hidden, and respects reduced motion. */
class RFAnnouncement extends HTMLElement {
  connectedCallback() {
    this.messages = Array.from(this.querySelectorAll('.rf-announce__msg'));
    if (this.messages.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.index = 0;
    this.speed = parseInt(this.dataset.speed, 10) || 4000;
    this.start();

    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.stop() : this.start();
    });
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    if (this.timer) return;
    this.timer = setInterval(() => this.advance(), this.speed);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  advance() {
    this.messages[this.index].removeAttribute('data-on');
    this.index = (this.index + 1) % this.messages.length;
    this.messages[this.index].setAttribute('data-on', 'true');
  }
}

if (!customElements.get('rf-announcement')) {
  customElements.define('rf-announcement', RFAnnouncement);
}
